// 1. 외부 패키지
import { Suspense } from "react"
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import media_atom from "../../atom/media-atom";
import PcTopSkeleton from "./pc-top-skeleton";
import MobileTopSkeleton from "./mobile-top-skeleton";
import Top from "./top";

// 4. 타입


const TopWrapper = () => {

	const media = useRecoilValue(media_atom);

	return (
		<Suspense fallback={media === "P" || media === "T" ? <PcTopSkeleton /> : <MobileTopSkeleton />}>
			<Top />
		</Suspense>
	);
};

export default TopWrapper;